export default __webpack_public_path__ + "static/media/on-the-rise-badge.acf1230e.svg";